import { Reveal, Overline } from "./Reveal";
import { CLIENTS } from "../data/content";

export const Clients = () => (
  <section id="clientes" className="relative py-16 sm:py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <div className="flex justify-center">
          <Overline>Quem confia na Gold</Overline>
        </div>
        <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">
          Nossos <span className="gold-text">clientes</span>
        </h2>
        <p className="mt-4 text-sm sm:text-base text-mist max-w-2xl mx-auto">
          Indústrias, construtoras, hospitais e prefeituras confiam na Gold
          Service para manter seus ambientes protegidos.
        </p>
      </Reveal>

      <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
        {CLIENTS.map((c, i) => (
          <Reveal key={c} delay={Math.min(i * 0.06, 0.36)}>
            <div
              data-testid={`client-card-${i}`}
              className="gold-border-gradient rounded-2xl bg-card px-4 py-5 text-center text-sm font-semibold text-zinc-200 transition-all duration-500 hover:text-gold-light hover:-translate-y-1"
            >
              {c}
            </div>
          </Reveal>
        ))}
        <Reveal delay={0.4}>
          <div className="rounded-2xl border border-dashed border-gold/40 px-4 py-5 text-center text-sm font-semibold text-gold">
            Sua empresa aqui
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.2} className="mt-10">
        <div className="mx-auto max-w-md overflow-hidden rounded-3xl border border-gold/25 bg-white p-2 shadow-[0_20px_60px_-20px_rgba(212,175,55,0.25)]">
          <img
            src="/images/clientes.jpeg"
            alt="Quadro de clientes Gold Service"
            loading="lazy"
            className="w-full rounded-2xl"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
